import {
  createRootRouteWithContext,
  ErrorComponent,
  Outlet,
  rootRouteId,
  useMatch,
  useRouter,
} from '@tanstack/react-router';
import { RootDocument } from '@/components/root-document';
import type { QueryClient } from '@tanstack/react-query';
import PageNotFound from '@/components/page-not-found';
import { LayoutDocument } from '@/components/layout-document';

interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: function RootComponent() {
    return (
      <RootDocument>
        <Outlet />
      </RootDocument>
    );
  },
  errorComponent: function RootErrorComponent(props) {
    const router = useRouter();
    const isRoot = useMatch({
      strict: false,
      select: (state) => state.id === rootRouteId,
    });
    console.log(isRoot);
    return (
      <RootDocument>
        <div>
          <h1>Root Error</h1>
          <pre>{JSON.stringify(props, null, 2)}</pre>
          {<button onClick={() => router.invalidate()}>Try again</button>}
          <ErrorComponent {...props} />
        </div>
      </RootDocument>
    );
  },
  notFoundComponent: function RootNotFoundComponent() {
    return (
      <RootDocument>
        <LayoutDocument>
          <PageNotFound className="mb-[100px] md:mb-[161px]" />
        </LayoutDocument>
      </RootDocument>
    );
  },
});
